import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from "./styles/style.module.css";
import ProgressBar from "../../../assets/components/ProgressBar";
import QuizRequests from "../../../assets/services/quiz";
import {
  setfinalizeQuiz,
  setMaxAnswer,
  setAnsweredQuestoinsCount,
} from "../../../assets/redux/actions/Quiz";

function QuestionsStatus({ progressColor, matchId }) {
  const [timeLeft, setTimeLeft] = useState(0);
  const ticketId = localStorage.getItem("Ticket");
  const dispatch = useDispatch();

  const { answeredQuestionsCount, max_answer, showCheatModal } = useSelector(
    ({ quiz }) => quiz
  );

  const getRemainingTime = useCallback(async () => {
    try {
      const remainingTime = await QuizRequests.getRemainingTime(ticketId);
      if (remainingTime) {
        setTimeLeft(remainingTime);
      } else {
        dispatch(setfinalizeQuiz(true));
      }
    } catch (error) {
      console.log(error);
    }
  }, [ticketId]);

  useEffect(() => {
    getRemainingTime();
    dispatch(QuizRequests.getAnswerStatus(matchId));
  }, [ticketId, matchId]);

  useEffect(() => {
    if (timeLeft <= 0) {
      getRemainingTime();
    }
  }, [timeLeft]);

  useEffect(() => {
    if (!showCheatModal) {
      getRemainingTime();
    }
  }, [showCheatModal]);

  useEffect(() => {
    return () => {
      dispatch(setMaxAnswer(0));
      dispatch(setAnsweredQuestoinsCount(0));
    };
  }, []);

  useEffect(() => {
    if (max_answer !== 0 && answeredQuestionsCount === max_answer) {
      setTimeout(() => {
        dispatch(setfinalizeQuiz(true));
      }, 3000);
    }
  }, [max_answer, answeredQuestionsCount]);

  useEffect(() => {
    if (timeLeft <= 0) {
      return;
    }
    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => Math.max(prevTime - 1000, 0));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const formatTime = (time) => {
    if (isNaN(time)) return "00";
    return String(time).padStart(2, "0");
  };

  const minutes = formatTime(Math.floor((timeLeft / (1000 * 60)) % 60));
  const seconds = formatTime(Math.floor((timeLeft / 1000) % 60));

  return (
    <div className="w-100">
      <div className={classes.quesitonStatusContainer}>
        <p>
          {minutes}:{seconds}
        </p>
        <p>
          {max_answer}/{answeredQuestionsCount}
        </p>
      </div>
      <div className={classes.progressContainer}>
        <ProgressBar
          height={"16px"}
          progress={(answeredQuestionsCount / max_answer) * 100}
          progressColor={progressColor}
          prgoressText={answeredQuestionsCount}
        />
      </div>
    </div>
  );
}

export default QuestionsStatus;
